import type { TechlineAssetEntity } from '../entities';

import { StsBackendOperation } from '../../../sts-backend-operation';
import { filterActiveAssetEntities, toTechlineAssetEntity, unwrapAssetResults } from '../helpers';

/** Parameters for fetching active assets. */
export type FetchActiveAssetsParams = {
    /** The case number to fetch assets for. */
    caseNumber: string;
};

/**
 * Fetch all active (Complete or Uploading) assets for a techline case.
 * Unwraps the API response envelope, maps to domain entities, and filters
 * to only visible assets.
 */
export class FetchActiveAssets extends StsBackendOperation {
    /**
     * Fetch and filter active assets for a case.
     *
     * @param params - the case to fetch assets for
     * @returns the active asset entities (Complete or Uploading)
     */
    async exec(params: FetchActiveAssetsParams): Promise<TechlineAssetEntity[]> {
        const { caseNumber } = params;
        const response = await this.client.retrieveCaseAssets({ caseNumber });

        if (!response.success) {
            return [];
        }

        const results = response.data?.results;

        if (!results?.length) {
            return [];
        }

        // Unwrap the API envelope and map to domain entities
        const assets = unwrapAssetResults(results);
        const entities = assets.map(toTechlineAssetEntity);

        return filterActiveAssetEntities(entities);
    }
}
